module.exports = __webpack_public_path__ + "static/media/ftfEquipe.563a518f.md";